import React, { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'
import MobileHeader from '@mobileShared/MobileHeader/MobileHeader'
import MobileRowItem from '../../../mobileComponents/mobileShared/MobileRowItem/MobileRowItem'
import { ScrollBody } from 'src/shared/ui/mobile/scroll-body'
import { useList } from 'effector-react'
import { $generalGroups } from '@entities/groups/model'

const CatalogPage = () => {
    const router = useRouter()
    const [heightHeader, setHeightHeader] = useState(80)
    const blockHeaderRef = useRef(null)
    useRef(null)
    useEffect(() => {
        if (blockHeaderRef?.current?.getBoundingClientRect().height !== heightHeader)
            setHeightHeader(blockHeaderRef?.current?.getBoundingClientRect().height)
    }, [blockHeaderRef?.current?.clientHeight])
    const generals = useList($generalGroups, {
        fn: (x) => (
            <MobileRowItem
                aProps={{
                    'data-general-catalog-id': x.id
                }}
                linkUrl={`${router.asPath}/${x.id}`}
                isLink
                isShowedRow>
                {x.title}
            </MobileRowItem>
        ),
        getKey: (item) => item.id
    })
    return (
        <React.Fragment>
            <MobileHeader searchInput={{ isShowed: true }} blockRef={blockHeaderRef}>
                Каталог
            </MobileHeader>
            <ScrollBody>{generals}</ScrollBody>
        </React.Fragment>
    )
}

CatalogPage.propTypes = {}

export default CatalogPage
